import React from 'react';

import { useSelector } from 'react-redux';
import * as profileSelectors from '@src/containers/ProfileVenue/selectors';
import { hooks as contactsHooks } from '@src/containers/ContactsModal';
import {
	ENTITY_TYPES,
	MODAL_VIEW_TYPES,
} from '@src/containers/ContactsModal/constants';
import FavourForUsersCDefault from '@src/components/FavourForUsers/connectors/default';
import { FAVOURED_ENTITY_TYPES } from '@src/containers/Favourites/constants';
import { ButtonGreenPhone as Button } from '@src/components/Button';
import { useActions as useInfoModalActions } from '@src/containers/InfoModals/hooks';
import { reachGoalYM } from '@old/utils/analytics/reachGoal';
import ProfileAside from '..';

const ProfileAsideDefaultConnector = () => {
	const { toggleStandaloneModal } = contactsHooks.useActions();
	const user = useSelector(profileSelectors.profileDetails);
	const medias = useSelector(profileSelectors.profileMedias);
	const title = useSelector(profileSelectors.profileTitle);
	const address = useSelector(profileSelectors.profileAddress);
	const landmark = useSelector(profileSelectors.profileLandmark);
	const rateValue = useSelector(profileSelectors.rateValue);
	const rateLabel = useSelector(profileSelectors.rateLabel);
	const rateQtty = useSelector(profileSelectors.rateQtty);
	const rateMod = useSelector(profileSelectors.rateMod);

	const handleClickContacts = React.useCallback(() => {
		toggleStandaloneModal({
			isVisible: true,
			target: {
				entityId: user.id,
				entityType: ENTITY_TYPES.VENUE,
			},
		});
	}, [toggleStandaloneModal, user.id]);

	const FavourForUsers = React.useCallback(() => {
		if (user.id !== undefined) {
			return (
				<FavourForUsersCDefault
					id={user.id}
					type={FAVOURED_ENTITY_TYPES.RESTAURANTS}
				/>
			);
		}

		return null;
	}, [user.id]);

	const AsideContactsButton = React.useCallback(
		(props) => <Button label={t('Показать контакты')} {...props} />,
		[],
	);

	const { setQuickInquireTarget, openQuickIngModal } = useInfoModalActions();

	const handleQuickInquire = React.useCallback(
		(e) => {
			const targetMedia = medias?.venue[0];
			const img = targetMedia ? { src: targetMedia.url } : null;
			setQuickInquireTarget({
				target: {
					id: user.id,
					title: user.name,
					img,
					details: {
						isCommission: user?.commission > 0,
					},
				},
			});
			openQuickIngModal();
			e.preventDefault();
		},
		[user, medias, setQuickInquireTarget, openQuickIngModal],
	);

	const handleClickShowMap = React.useCallback(() => {
		reachGoalYM('microgoal_card_map');
		toggleStandaloneModal({
			isVisible: true,
			viewType: MODAL_VIEW_TYPES.FULL,
			target: {
				entityId: user.id,
				entityType: ENTITY_TYPES.VENUE,
			},
		});
	}, [toggleStandaloneModal, user.id]);

	return (
		<ProfileAside
			title={title}
			rateMod={rateMod}
			rateValue={rateValue?.toString().replace('.', ',')}
			rateLabel={rateLabel}
			rateQtty={rateQtty}
			address={address}
			landmark={landmark}
			onClickShowMap={handleClickShowMap}
			onClickContacts={handleClickContacts}
			Favorites={FavourForUsers}
			ContactsButton={AsideContactsButton}
			onClickFastOrder={
				user.isCanRequest ? handleQuickInquire : undefined
			}
		/>
	);
};

export default ProfileAsideDefaultConnector;
